var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bmap',{ref:"bmap",attrs:{"initPoint":_vm.initPoint,"revisability":false,"hasSearch":false,"hasThemeSwitcher":false},on:{"mapHandler":_vm.mapHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }